export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/selection/sparse.js
// module id = 158
// module chunks = 0 1 2 3 4